import {css} from 'lit';
export const styles = css`:host {
  line-height: 1;
}

.bu-btn {
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  display: block;
}

.btn-naked-dark {
  display: flex;
}

.btn-naked-dark span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

.btn-naked-dark.attend bu-icon {
      color: var(--success);
    }

.btn-naked-dark.not-attend bu-icon {
      color: var(--danger);
    }
`;
export default styles;
